<template>
    <div class="survey">
        <my-header></my-header>
        <el-row :span="24" class="bg-color">
            <el-col :span="20" :xs="{span:20,offset:2}" :sm="{span:20,offset:2}" :md="{span:20,offset:2}">
                <nav class="nav">
                    <ul>
                        <li v-for="(list,index) in navList"  :class="{ active:changeRed == index}"  :key="index" @click="active(index)">{{list.text}}</li>
                    </ul>
                </nav>
            </el-col>
        </el-row>
        <el-row :span="24">
            <el-col :xs="{span:20,offset:2}" :sm="{span:20,offset:2}" :md="{span:20,offset:2}">
                <div class="surery">
                    <div class="surery_left">
                        <img src="../../assets/adressC.png" alt="about" >
                    </div>
                    <div class="surery_right">
                        <div class="list_top" >
                            <span>联系我们</span>
                            <span style="width:100%;height:1px;background-color:#ccc;margin:10px 0;"></span>
                            <ul>
                                
                                <!-- <li><span style="display:inline-block;">电话:</span> 13603362946</li> -->
                                <li><span style="display:inline-block;"><i class="el-icon-phone"></i></span> 13603362946</li>
                                <!-- <li><span style="display:inline-block;"><i class="el-icon-phone"></i></span> 13603362946</li> -->
                                <li><span style="display:inline-block;"><i class="el-icon-platform-eleme"></i></span> nastia@rocket86.com</li>
                                <!-- <li><span style="display:inline-block;"><i class="el-icon-platform-eleme"></i></span> nastia@rocket86.com</li> -->
                                <li><span style="display:inline-block;"><i class="el-icon-location-information"></i></span> 天津自贸试验区（空港经济区）中心大道与东五道交口</li>
                                <!-- <li><span style="display:inline-block;"><i class="el-icon-location-information"></i></span> Room 9-3-701, Yijing  Apartment, The Central Avenue ,Airport Economic Zone, Tian Jin, China</li> -->
                            </ul>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row :span="24">
            <el-col :xs="{span:20,offset:2}" :sm="{span:20,offset:2}" :md="{span:20,offset:2}">
                <div class="surery">
                    
                    <div class="surery_right">
                        <div class="list_top" >
                            <span>联系我们</span>
                            <span style="width:100%;height:1px;background-color:#ccc;margin:10px 0;"></span>
                            <ul>
                                
                                <!-- <li><span style="display:inline-block;">电话:</span> 13603362946</li> -->
                                <li><span style="display:inline-block;"><i class="el-icon-phone"></i></span> +7 903 571 23 48</li>
                                <!-- <li><span style="display:inline-block;"><i class="el-icon-phone"></i></span> 13603362946</li> -->
                                <li><span style="display:inline-block;"><i class="el-icon-platform-eleme"></i></span> mospeter@yandex.ru</li>
                                <!-- <li><span style="display:inline-block;"><i class="el-icon-platform-eleme"></i></span> nastia@rocket86.com</li> -->
                                <!-- <li><span style="display:inline-block;"><i class="el-icon-location-information"></i></span> 天津自贸试验区（空港经济区）中心大道与东五道交口</li> -->
                                <li><span style="display:inline-block;"><i class="el-icon-location-information"></i></span> 俄罗斯联邦 莫斯科市 图拉大街10号 5楼1座 152室-115191</li>
                            </ul>
                        </div>
                    </div>
                    <div class="surery_left">
                        <img src="../../assets/adressR.png" alt="about" >
                    </div>
                </div>
            </el-col>
        </el-row>
        <my-footer></my-footer>
    </div>
</template>

<script>
import MyHeader  from '../headerPage'
import MyFooter  from '../footerPage'
export default {
    components:{ MyHeader,MyFooter},
    data() {
        return {
            changeRed:3,
            navList:[{
                text:"首页"
            },{
                text:"简介概况"
            },{
                text:"会员中心"
            },{
                text:"联系我们"
            }],
        }
    },
    methods:{
        active(index){
            this.changeRed = index;
            if(index == 0){
                this.$router.push({name:"homePage"})
            }else if(index == 1){
                this.$router.push({name:"surveyPage"})
            }else if(index == 2){
                this.$router.push({name:"memberPage"})
            }else if(index == 3){
                this.$router.push({name:"aboutPage"})
            }
        },
    }
}
</script>

<style scoped >
/* 导航 */
.bg-color{
        background-color: #DBDBDB;
    }
    .nav{
        width:100%;
        height:auto;
        background-color: #DBDBDB;
    }
    .nav ul{
        height:40px;
        margin:0 auto;
        
    }
    .nav ul li {
        float:left;
        width:25%;
        box-sizing: border-box;
        padding:10px 10px;
        color:#5B5B5B;
        font-size:20px;
        font-weight:600;
        text-align: center;
        cursor:pointer;
    }
    .nav ul li.active{
        color:#fff;
        background-color: #1f3356;
    }
    .surery{
        width:100%;
        height:auto;
        margin-top:40px;
    }
    .surery .surery_left{
        float:left;
        width:50%;
        height:auto;
        min-height:400px;
        background-color: #eee;
    }
    .surery .surery_left img{
        display:block;
        width:80%;
        height:320px;
        margin:40px auto;
    }
    .surery .surery_left img:hover{
       transform:scale(1.2);
    }
    .surery .surery_right{
        float:left;
        width:50%;
        height:auto;
        min-height:400px;
        background-color: #eee;
    }
    
    .surery_right .list_top{
        width:100%;
        height:auto;
        clear:both;
        box-sizing: border-box;
        padding:20px 20px;
        cursor: default;
    }
    .list_top span{
        display:block;
        font-size:30px;
        font-weight:600;
        color:#333;
        cursor: default;
    }
    .list_top ul li span{
        font-size:26px;
    }
    .list_top ul li{
        box-sizing: border-box;
        padding:4px 10px;
        font-size:20px;
    }
    .list_top ul i{
        margin-right:10px;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/ZH-CN/aboutPage.vue